import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEOHead } from '../../hooks/useSEOHead';
import PageHero from '../../components/feature/PageHero';
import ServiceAreasList from './components/ServiceAreasList';
import WhyChooseUs from './components/WhyChooseUs';
import NearbyAreasSection from './components/NearbyAreasSection';
import ReadyToShopCta from './components/ReadyToShopCta';
import { injectJsonLd, removeJsonLd } from '../../lib/schemaBuilder';

export default function ServiceAreasPage() {
  useSEOHead({
    title: 'Service Areas | Oregon & Washington | Rockhound Auto',
    description: 'Rockhound Auto delivers quality used cars throughout Oregon and Washington. Serving Portland, Seattle, Astoria, Seaside, Bend, Eugene, and the Pacific Northwest.'
  });

  useEffect(() => {
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://rockhoundauto.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Service Areas',
          item: 'https://rockhoundauto.com/service-areas',
        },
      ],
    };

    injectJsonLd('schema-service-areas-breadcrumb', breadcrumbSchema);

    return () => {
      removeJsonLd('schema-service-areas-breadcrumb');
    };
  }, []);

  return (
    <>
      <PageHero
        theme="dark"
        backgroundImage="https://public.readdy.ai/ai/img_res/65440d6956821042b7237e903d8189fb.jpg"
        eyebrow={{
          icon: 'ri-map-pin-line',
          text: 'Serving the Pacific Northwest'
        }}
        title={
          <>
            We Deliver Quality Used Cars{' '}
            <span className="text-[#E8B84B]">Throughout Oregon &amp; Washington</span>
          </>
        }
        subtitle="From Portland to Seattle, we bring honest, transparent car buying to communities across the Pacific Northwest. Free delivery available to most areas."
        ctas={[
          { label: 'View Inventory', href: '/inventory', variant: 'primary', icon: 'ri-car-line' },
          { label: 'Contact Us', href: '/contact', variant: 'secondary', icon: 'ri-phone-line' }
        ]}
        trustSignals={[
          { icon: 'ri-truck-line', text: 'Free Delivery Available' },
          { icon: 'ri-shield-check-line', text: 'No-Pressure Sales' },
          { icon: 'ri-heart-line', text: 'Supporting Local Rescues' }
        ]}
      />

      <ServiceAreasList />
      <WhyChooseUs />
      <NearbyAreasSection />
      <ReadyToShopCta />
    </>
  );
}